import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, Image, Table } from 'react-bootstrap';

// Components
import { DetailTemplate, DetailHeader, DetailAccordion } from '../../DetailTemplate';

// Utilities
import utils from '../../../_helpers/utils';
import MetaDecorator from '../../../_helpers/MetaDecorator';

// Styles
import '../../Detail/Detail.scss';

export default function Achievement({ selected, toggleCompactMode }) {
  const apiUrl = `/achievements/${selected}`;

  return (
    <DetailTemplate apiUrl={apiUrl}>
      {(data) => {
        const achievement = data;

        return (
          <>
            <MetaDecorator title={achievement.sDisplayName} />
            <DetailHeader toggleCompactMode={toggleCompactMode}>
              <Image
                src={achievement.aMilestones[0].eRoleIcon}
                alt={achievement.sDisplayName}
                onError={utils.handleImageError}
              />
              <h4 className="d-inline align-middle">
                {achievement.sDisplayName}
              </h4>
            </DetailHeader>
            <Row>
              <Description achievement={achievement} />
              <Col md={12} className="p-0">
                {achievement.aMilestones.map((m, i) => (
                  <Action
                    key={i}
                    achievement={achievement}
                    milestone={m}
                    index={i}
                  />
                ))}
              </Col>
            </Row>
          </>
        );
      }}
    </DetailTemplate>
  );
}

class Description extends React.Component {
  render() {
    return (
      <Col md={12} className="description">
        <Row noGutters>
          <Col md={8} className="mb-3">
            <h6>DESCRIPTION</h6>
            <small>{this.props.achievement.sDescription}</small>
          </Col>
        </Row>
      </Col>
    )
  }
}

class Action extends React.Component {
  calculateDifference(level) {
    let final = this.props.achievement.aMilestones[level].fPassMark_0;

    if (level > 0) final -= this.props.achievement.aMilestones[level-1].fPassMark_0;
    
    return final;
  }

  render() {
    
    var collapseOpen = '0';
    const index = this.props.index;
    const milestone = this.props.milestone;
    const rewards = utils.combineRewardPackageItems(milestone.eReward);

    var toggle = (
      <>
      {`RANK ${index+1} // ${milestone.sTitle}`}
      <br />
      <span className="text-muted">
        {
          `${this.calculateDifference(index).toLocaleString()} action${this.calculateDifference(index) > 1 ? 's' : ''} 
          // ${milestone.fPassMark_0.toLocaleString()} total action${milestone.fPassMark_0 > 1 ? 's' : ''}
          // (${this.props.achievement.eActivities_0.sAPBDB})`
        }
      </span>
      </>
    )

    var collapse = <p className="m-3">No rewards.</p>;

    if (rewards.length > 0) {
      collapseOpen = '1';
      collapse = (
        <Table className="item-table m-0">
          <tbody>
            {rewards.map(item => (
            <tr key={item.sAPBDB}>
              <td className="small-width">
                <NavLink to={`/items/${item.sAPBDB}`}>
                  <Image 
                    width={32}
                    src={item.eHUDImage} 
                    alt={item.sDisplayName}
                    onError={utils.handleImageError} />
                </NavLink>
              </td>
              <td>
                <NavLink 
                  to={`/items/${item.sAPBDB}`} 
                  dangerouslySetInnerHTML={{__html: utils.convertColorCode(item.sDisplayName)}} />
              </td>
            </tr>
            ))}
          </tbody>
        </Table>
      )
    }

    return (
      <DetailAccordion 
        ukey={milestone.sAPBDB} 
        toggle={toggle} 
        collapse={collapse}
        open={collapseOpen} />
    )
  }
}
